import { gql } from '@apollo/client';

export const UPDATE_MEDISPAN_ALERT_STATUS = gql`
  mutation UpdateMedispanAlertStatus($data: UpdateMedispanAlertInput!) {
    updateMedispanAlertStatus(data: $data) {
      medispanAlertId
    }
  }
`;
